// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right_box":"right_box-3oVLut9m","stock_box":"stock_box-1dChzOMz"};